(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

class RelativeHeader extends HTMLElement {
  constructor() {
    super();
    this.header = this;
    this.dropdowns = this.querySelectorAll("details.site-header__label");
    this.setupListener();
  }

  setupListener() {
    this.dropdowns.forEach((dropdown) => {
      dropdown.querySelector("summary").addEventListener('click', this.updateActiveDialog.bind(this));
    });
  }

  updateActiveDialog(e) {
    let thisDropdown = e.target.parentNode;

    // Close all other dropdowns
    this.dropdowns.forEach((dropdown) => {
      if (dropdown !== thisDropdown) {
        dropdown.removeAttribute("open");
      }
    });

    // Toggle header class based on dropdown state
    if (thisDropdown.hasAttribute("open")) {
      if (!thisDropdown.classList.contains('__scroll')) {
        document.body.classList.remove('__mobile-overflow-none');
      }
      this.header.classList.remove('__dropdown-open');
    } else {
      if (!thisDropdown.classList.contains('__scroll')) {
        document.body.classList.add('__mobile-overflow-none');
      }
      this.header.classList.add('__dropdown-open');
    }
  }
}

customElements.define('relative-header', RelativeHeader);

class StickyHeader extends RelativeHeader {
  constructor() {
    super();
    this.lastScrollTop = window.pageYOffset;
    this.isSpare = this.matches(':nth-of-type(2)');
    if (this.isSpare) return;
    // Always fixed to the top; the page is padded by the header's height so nothing jumps.
    this.classList.remove('__relative');
    this.setHeight = this.setHeight.bind(this);
    this.setHeight();
    window.addEventListener('resize', this.setHeight);
    if ('ResizeObserver' in window) new ResizeObserver(this.setHeight).observe(this);
    document.addEventListener('scroll', this.updateClass.bind(this), { passive: true });
    this.updateClass();
  }

  setHeight() {
    var h = this.offsetHeight;
    if (h > 0) document.documentElement.style.setProperty('--rf-header-h', h + 'px');
  }

  updateClass() {
    if (this.isSpare) return;
    var y = Math.max(0, window.pageYOffset);
    var delta = y - this.lastScrollTop;
    var menuOpen = !!this.querySelector('details[open]');
    this.classList.remove('__relative');
    this.classList.toggle('__scrolled', y > 4);

    if (menuOpen || y <= this.offsetHeight || this.classList.contains('__always-show-nav')) {
      this.classList.remove('__hidden');
    } else if (delta > 6) {
      this.classList.add('__hidden');      // scrolling down: tuck the header away
    } else if (delta < -6) {
      this.classList.remove('__hidden');   // scrolling up: bring it straight back
    }
    if (Math.abs(delta) > 6) this.lastScrollTop = y;
  }
}

customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();
})();
